<template>
  <div class="animated fadeIn">
    <div v-if="$route.name == 'Puzzle Game'" class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-align-justify" /> Puzzle Game
            <router-link
              v-if="$_allowCreating"
              :to="'/admin/puzzle-game-images/new'"
              class="pull-right btn btn-success btn-sm"
              exact
            >
              New
            </router-link>
          </div>

          <div class="card-block">
            <input v-model="searchQuery" type="text" class="form-control" placeholder="Search by puzzle game image title">
          </div>

          <EmptyBtns
            :empty-search="emptySearch"
            @showEmpty="() => emptySearch = true"
            @showAll="() => emptySearch = false"
          />

          <div class="card-block spinner-parent">
            <spinner ref="spinner" size="md" text="Loading ..." />

            <nav>
              <pager
                :total="total"
                :offset="offset"
                :size="perPage"
                @page-changed="$_changePage"
              />
            </nav>
            <div class="table-responsive">
              <table v-if="total" class="entities table table-bordered table-striped table-sm">
                <thead>
                  <tr>
                    <th class="table-list__cell--narrow">
                      <input ref="allEntities" type="checkbox" @change="$_selectAllEntities">
                    </th>
                    <th>ID</th>
                    <th>Thumbnail</th>
                    <th>Title</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in entities" :key="item.id" :data-id="item.id">
                    <td class="table-list__cell--narrow text-center">
                      <input v-model="choosenEntities" type="checkbox" :value="item.id">
                    </td>
                    <td>{{ item.id }}</td>
                    <td class="table-list__cell--narrow text-center">
                      <img :src="adaptUrl(item.thumbnail)" alt="" style="max-height: 100px;">
                    </td>
                    <td>{{ item.title }}</td>
                    <td class="table-list__cell--narrow">
                      <router-link
                        v-if="$_allowUpdating(item)"
                        class="btn btn-primary btn-sm"
                        :to="`/admin/puzzle-game-images/edit/${item.id}`"
                      >
                        Edit
                      </router-link>
                      <button
                        v-if="$_allowDeleting(item)"
                        class="btn btn-danger btn-sm"
                        @click="$_deleteEntity(item, 'games/puzzles/', 'Puzzle Game')"
                      >
                        Delete <span :ref="`deleteBtnLoader_${item.id}`" class="btn-loader" style="display: none;" />
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div v-if="total === 0">There are no entities for your request</div>

            <nav>
              <pager
                :total="total"
                :offset="offset"
                :size="perPage"
                @page-changed="$_changePage"
              />
            </nav>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Pager from '@/global/components/Pager';
import EmptyBtns from '@/global/components/EmptyBtns';
// Mixins
import ListPageMixin from '@/mixins/ListPageMixin';
import CommonPageMixin from '@/mixins/CommonPageMixin';

export default {
  name: 'PuzzleImageIndex',

  components: {
    pager: Pager,
    EmptyBtns,
  },

  mixins: [ListPageMixin, CommonPageMixin],

  methods: {
    adaptUrl(url) {
      if (!url) {
        return null;
      }
      if (url[0] === '/') {
        return url.substring(1);
      }
      return url;
    },
    getSource() {
      if (this.$refs.spinner) { this.$refs.spinner.show(); }
      const searchString = encodeURI(this.searchQuery);
      const page = this.perPage ? (this.offset / this.perPage + 1) : 1;
      const searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(`${this.$config.app_api.prefix}games/puzzles`, {
        params: {
          search_string: searchString,
          page,
        },
      }).then((response) => {
        if (this.$refs.spinner) { this.$refs.spinner.hide(); }
        this.total = response.data.meta.pagination.total;
        this.perPage = response.data.meta.pagination.per_page;
        const puzzles = _.cloneDeep(response.data);
        delete puzzles.meta;
        this.entities = Object.keys(puzzles).map(e => puzzles[e]);
      }).catch((error) => { this.$_errorCallback(error); });
    },
  },
};
</script>



// WEBPACK FOOTER //
// Index.vue?54bca19e